// extracted by mini-css-extract-plugin
export default {"cardShelf":"cardShelf__MjAyZ","hoverScale":"hoverScale__Zjg5N"};